import React from "react";
import { Link } from "react-router-dom";
import FancyTitle from "@/components/FancyTitle";
import { ArrowLeft } from "lucide-react";

const HOGARTH_IMG =
  "/img/southwark.jpg";

export default function Fields() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Background — cropped to show only flags and sky at top */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url("${HOGARTH_IMG}")`,
          backgroundSize: "auto 230%",
          backgroundPosition: "left top",
          backgroundRepeat: "no-repeat",
        }}
        aria-label="Southwark Fair — William Hogarth, 1733"
      />
      <div className="absolute inset-0 bg-ink/65" />
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(ellipse at center, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.7) 100%)" }}
      />

      {/* Back strip */}
      <div className="relative z-10">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-sans text-[0.7rem] uppercase tracking-[0.24em] text-parchment/80 hover:text-parchment"
            data-testid="fields-back-link"
          >
            <ArrowLeft className="w-3 h-3" strokeWidth={1.5} /> Invitations
          </Link>
          <div className="press-title text-xs md:text-sm uppercase tracking-[0.3em] text-parchment/80">
            Part III
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center px-6" style={{ minHeight: "calc(100vh - 88px)" }}>
        <div className="text-center max-w-2xl">
          <FancyTitle as="h1" className="press-title text-5xl sm:text-6xl lg:text-7xl text-parchment mt-6 uppercase tracking-[0.28em] sm:tracking-[0.34em] leading-[1.15]">
            The Field of Fun
          </FancyTitle>

          <div className="flex items-center justify-center gap-4 my-10">
            <span className="flex-1 h-px bg-parchment/40 max-w-[120px]" />
            <span className="press-title italic text-parchment/80 tracking-widest text-sm uppercase">~</span>
            <span className="flex-1 h-px bg-parchment/40 max-w-[120px]" />
          </div>

          <p className="font-display italic text-parchment text-3xl md:text-5xl leading-[1.1]" data-testid="fields-coming-soon">
            Coming Soon
          </p>
        </div>
      </div>
    </div>
  );
}
